import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { callApi } from "../../../ApiHelper/ApiHelper";
import MainHeading from "../../../components/comman/MainHeading";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LockAttConfirmationModel from "./LockAttConfirmationModel";
import { formatAmount } from "../../../utility/CommonFunctions";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import NoRecordIcon from "../../../components/Icons/NoRecordIcon";
import EditIcon from "../../../components/Icons/EditIcon";
import CheckIcon from "../../../components/Icons/CheckIcon";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";

const formatValue = (val) => {
  if (val === null || val === undefined) return "";
  const num = Number(val);
  const parts = num.toString().split('.');
  if (parts[1] && parts[1].length > 2) {
    return num.toFixed(2);
  }
  return val;
};


export default function ViewCreateSalaryDetails() {
  const [pageStates, setPageStates] = useState({
    salaryList: [],
    searchQuery: "",
    tableLoader: false,
    isLoadingPtUpdate: false,
  });
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [modal, setModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [ptTaxes, setPtTaxes] = useState({});
  const [isUpdatingSalary, setIsUpdatingSalary] = useState(false);
  const { month } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isOffice = location?.state?.userType === 1;
  console.log("location", location);

  const toggleModal = (type = "") => {
    setModalType(type);
    setModal((prev) => !prev);
  };

  useEffect(() => {
    getLockedSalary();
  }, []);

  const getLockedSalary = () => {
    let options = {
      method: "GET",
    };
    const filterData = {
      siteId: filterDetails?.siteId,
      salaryMonth: month?.replace("-", "/"),
      ...(location?.state?.userType !== undefined && { userType: location?.state?.userType }),
    };
    const Url =
      apiUrl.get_locked_user_salary + "?" + MainFilterHandler(filterData);
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.userSalaryPreview?.map((item) => ({
          ...item,
          basicSalary: formatAmount(item?.["Basic Salary"]),
          grossSalary: formatAmount(item?.["Gross Salary"]),
          deductionAmount: formatAmount(item?.totalDeductions),
          netPay: formatAmount(item?.netSalary),
        }));
        setPageStates((pre) => ({
          ...pre,
          salaryList: newData,
        }));
      } else {
        toast.error(res?.message)
      }
    });
  };

  const handleCreateSalary = () => {
    setIsLoading(true);
    callApi(apiUrl.accept_monthly_user_salary, {
      method: "POST",
      data: {
        siteId: filterDetails?.siteId,
        month: month?.replace("-", "/"),
        ...(isOffice && { userType: 1 }),
      },
    }).then((res) => {
      setIsLoading(false);
      if (res?.status) {
        toggleModal();
        navigate(-1);
        toast.success("Salary Created");
      } else {
        toast.error(res?.message);
      }
    });
  };

  const handlePtTaxChange = (userId, headId, amount) => {
    setPtTaxes((prev) => ({
      ...prev,
      [`${userId}_${headId}`]: {
        userId,
        headId,
        amount
      },
    }));
  };

  const handleUpdatePTTax = () => {
    const headField = isOffice ? 'officeSalaryHeadId' : 'siteSalaryHeadId';
    const payload = Object.values(ptTaxes).map((item) => ({
      [headField]: item?.headId,
      userId: item?.userId,
      amount: Number(item.amount),
    }));

    if (payload.length === 0) {
      toast.warning("No changes made");
      return;
    }

    const submitData = {
      siteId: filterDetails?.siteId,
      month: month?.replace("-", "/"),
      updates: payload,
      ...(isOffice && { userType: 1 }),
    }
    setPageStates((pre) => ({
      ...pre,
      isLoadingPtUpdate: true,
    }));
    callApi(apiUrl.update_monthly_user_salary_preview, {
      method: "POST",
      data: submitData,
    }).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        isLoadingPtUpdate: false,
      }));
      if (res?.status) {
        toast.success("Deductions Updated");
        setIsUpdatingSalary(false);
        setPtTaxes({});
        getLockedSalary();
      } else {
        toast.error(res?.message);
      }
    });

  };

  return (
    <>
      {pageStates?.isLoadingPtUpdate && <BgBlurLoader />}
      <div className="content">
        <MainHeading
          title={`Salary Details – ${location?.state?.siteName}`}
          showBackButton={true}
          buttonIcon={isUpdatingSalary ? <CheckIcon /> : <EditIcon />}
          buttonText={isUpdatingSalary ? "Confirm Update" : (isOffice ? "Update Salary" : "Update PT Tax")}
          clickHandler={() => {
            if (isUpdatingSalary) {
              handleUpdatePTTax();
            } else {
              setIsUpdatingSalary(true);
            }
          }}
        >
          {isUpdatingSalary && (
            <button
              type="button"
              className="btn btn-outline-secondary px-4 ms-2"
              onClick={() => {
                setIsUpdatingSalary(false);
                setPtTaxes({});
              }}
            >
              Cancel
            </button>
          )}
          <button
            disabled={isLoading || isUpdatingSalary}
            type="button"
            className="btn btn-outline-primary px-5"
            onClick={() => toggleModal("createSalary")}
          >
            {"Create Salary"}
          </button>

        </MainHeading>
        <div className="card mb-4">
          <div className="card-body">

            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr className="border border-2">
                    <th className="align-middle" style={{ minWidth: "150px" }}>Employee Info</th>
                    <th className="align-middle" style={{ minWidth: "200px" }}>Allowances Breakdown</th>
                    <th className="align-middle" style={{ minWidth: "200px" }}>Employer Contribution</th>
                    <th className="align-middle" style={{ minWidth: "200px" }}>Deductions Breakdown</th>
                    <th className="align-middle" style={{ minWidth: "300px" }}>Salary Breakdown</th>
                  </tr>
                </thead>
                <tbody>
                  {pageStates?.tableLoader ? (
                    <tr>
                      <td colSpan="5" className="text-center py-5">
                        <Spinner />
                      </td>
                    </tr>
                  ) : pageStates?.salaryList?.length > 0 ? (
                    pageStates?.salaryList.map((item, index) => {
                      const basic = item?.["Basic Salary"] || 0;
                      const gross = item?.["Gross Salary"] || 0;

                      const allowances = item?.salaryComponents?.filter(c =>
                        c.type === "earning" &&
                        !["Gross Salary", "Net Salary", "Basic Salary", "PF Employer Contribution", "ESI Employer Contribution", "PF Wages", "Daily Wages"].includes(c.name)
                      ) || [];
                      const mappedAllowances = allowances.map(a => {
                        const headId = a.officeSalaryHeadId || a.siteSalaryHeadId;
                        const customVal = ptTaxes[`${item.id}_${headId}`];
                        return {
                          ...a,
                          amount: customVal !== undefined ? Number(customVal.amount) : a.amount,
                        };
                      });
                      const totalAllowances = mappedAllowances.reduce((acc, curr) => acc + curr.amount, 0);

                      const employerContribs = item?.salaryComponents?.filter(c =>
                        ["PF Employer Contribution", "ESI Employer Contribution"].includes(c.name)
                      ) || [];
                      const mappedEmployerContribs = employerContribs.map(e => {
                        const headId = e.officeSalaryHeadId || e.siteSalaryHeadId;
                        const customVal = ptTaxes[`${item.id}_${headId}`];
                        return {
                          ...e,
                          amount: customVal !== undefined ? Number(customVal.amount) : e.amount,
                        };
                      });
                      const totalEmployerContribs = mappedEmployerContribs.reduce((acc, curr) => acc + curr.amount, 0);

                      const deductions = item?.salaryComponents?.filter(c => c.type === "deduction") || [];

                      let updatedDeductions = 0;
                      let originalEditableSum = 0;

                      deductions.forEach(d => {
                        const isPtTax = d.name.toUpperCase() === "PT TAX";
                        const isEditable = isPtTax || isOffice;
                        const headId = d.officeSalaryHeadId || d.siteSalaryHeadId;

                        if (isEditable) {
                          originalEditableSum += d.amount;
                          const customInput = ptTaxes[`${item.id}_${headId}`];
                          updatedDeductions += customInput !== undefined ? Number(customInput.amount) : d.amount;
                        }
                      });

                      const totalDeductions = (item.totalDeductions || 0) - originalEditableSum + updatedDeductions;
                      const originalAllowancesSum = allowances.reduce((acc, curr) => acc + curr.amount, 0);
                      const allowanceDiff = totalAllowances - originalAllowancesSum;

                      const dynamicGross = gross + allowanceDiff;
                      const netPay = (item.netSalary || 0) + allowanceDiff + originalEditableSum - updatedDeductions;


                      return (
                        <tr key={item.id || index} className="border border-2">
                          {/* Employee Info */}
                          <td className="align-top py-2">
                            <div className="d-flex flex-column text-center gap-1">
                              <span className="fw-bold text-dark fs-5">{item.name}</span>
                              <span className="badge bg-primary fw-semibold fs-6 align-self-center py-1 mb-2">
                                {item.employeeCode}
                              </span>
                              <div className="d-flex justify-content-center gap-2">
                                <div className="d-flex flex-column align-items-center bg-light border rounded px-2 py-1 flex-fill">
                                  <span className="small fw-semibold text-muted" style={{ fontSize: "0.8rem" }}>Paid</span>
                                  <span className="fw-bold text-success">{item?.paidDays}</span>
                                </div>
                                <div className="d-flex flex-column align-items-center bg-light border rounded px-2 py-1 flex-fill">
                                  <span className="small fw-semibold text-muted" style={{ fontSize: "0.8rem" }}>Absent</span>
                                  <span className="fw-bold text-danger">{item?.absent}</span>
                                </div>
                                <div className="d-flex flex-column align-items-center bg-light border rounded px-2 py-1 flex-fill">
                                  <span className="small fw-semibold text-muted" style={{ fontSize: "0.8rem" }}>Leave</span>
                                  <span className="fw-bold text-info">{item?.leave}</span>
                                </div>
                                <div className="d-flex flex-column align-items-center bg-light border rounded px-2 py-1 flex-fill">
                                  <span className="small fw-semibold text-muted" style={{ fontSize: "0.8rem" }}>Pending</span>
                                  <span className="fw-bold text-warning">{item?.pending}</span>
                                </div>
                              </div>
                            </div>
                          </td>
                          {/* Allowances Breakdown */}
                          <td className="align-top py-2 border-start border-end">
                            <div className="d-flex flex-column gap-1">
                              {mappedAllowances.map((a, idx) => {
                                const headId = a.officeSalaryHeadId || a.siteSalaryHeadId;
                                return (
                                  <React.Fragment key={a.id}>
                                    <div className="d-flex justify-content-between align-items-center px-2 py-1">
                                      <span className="text-muted small">{a.name}</span>
                                      {isOffice ? (
                                        <input
                                          type="number"
                                          className="form-control form-control-sm text-end text-success fw-medium"
                                          style={{ width: "80px", padding: "0.1rem 0.25rem", height: "auto" }}
                                          value={ptTaxes[`${item.id}_${headId}`] !== undefined ? ptTaxes[`${item.id}_${headId}`].amount : formatValue(a.amount)}
                                          onChange={(e) => handlePtTaxChange(item.id, headId, e.target.value)}
                                          disabled={!isUpdatingSalary}
                                        />
                                      ) : (
                                        <span className="fw-medium small text-success">{formatAmount(a.amount)}</span>
                                      )}
                                    </div>
                                    {idx < mappedAllowances.length - 1 && (
                                      <div className="border-bottom border-secondary my-0 border-opacity-25"></div>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </div>
                          </td>

                          {/* Employer Contribution */}
                          <td className="align-top py-2 border-end">
                            <div className="d-flex flex-column gap-1">
                              {mappedEmployerContribs.map((e, idx) => {
                                const headId = e.officeSalaryHeadId || e.siteSalaryHeadId;
                                return (
                                  <React.Fragment key={e.id}>
                                    <div className="d-flex justify-content-between align-items-center px-2 py-1">
                                      <span className="text-muted small">{e.name}</span>
                                      {isOffice ? (
                                        <input
                                          type="number"
                                          className="form-control form-control-sm text-end text-success fw-medium"
                                          style={{ width: "80px", padding: "0.1rem 0.25rem", height: "auto" }}
                                          value={ptTaxes[`${item.id}_${headId}`] !== undefined ? ptTaxes[`${item.id}_${headId}`].amount : formatValue(e.amount)}
                                          onChange={(e) => handlePtTaxChange(item.id, headId, e.target.value)}
                                          disabled={!isUpdatingSalary}
                                        />
                                      ) : (
                                        <span className="fw-medium small text-success">{formatAmount(e.amount)}</span>
                                      )}
                                    </div>
                                    {idx < mappedEmployerContribs.length - 1 && (
                                      <div className="border-bottom border-secondary my-0 border-opacity-25"></div>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </div>
                          </td>

                          {/* Deductions Breakdown */}
                          <td className="align-top py-2 border-end">
                            <div className="d-flex flex-column gap-1">
                              {deductions.map((d, idx) => {
                                const isPtTax = d.name.toUpperCase() === "PT TAX";
                                const isEditable = isPtTax || isOffice;
                                const headId = d.officeSalaryHeadId || d.siteSalaryHeadId;

                                return (
                                  <React.Fragment key={d.id}>
                                    <div className="d-flex justify-content-between align-items-center px-2 py-1">
                                      <span className="text-muted small">{d.name}</span>
                                      {isEditable ? (
                                        <input
                                          type="number"
                                          className="form-control form-control-sm text-end text-danger fw-medium"
                                          style={{ width: "80px", padding: "0.1rem 0.25rem", height: "auto" }}
                                          value={ptTaxes[`${item.id}_${headId}`] !== undefined ? ptTaxes[`${item.id}_${headId}`].amount : formatValue(d.amount)}
                                          onChange={(e) => handlePtTaxChange(item.id, headId, e.target.value)}
                                          disabled={!isUpdatingSalary}
                                        />
                                      ) : (
                                        <span className="fw-medium small text-danger">{formatAmount(d.amount)}</span>
                                      )}
                                    </div>
                                    {idx < deductions.length - 1 && (
                                      <div className="border-bottom border-secondary my-0 border-opacity-25"></div>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </div>
                          </td>

                          {/* Salary Breakdown */}
                          <td className="align-top py-2">
                            <div className="d-flex flex-column gap-1 px-4 bg-light bg-opacity-50 rounded-4 shadow-sm">
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex flex-column text-start">
                                  <span className="fw-bold small text-dark">Gross Income</span>
                                  <span style={{ fontSize: "0.85rem" }}>Basic ({formatAmount(basic)}) + Allowances ({formatAmount(totalAllowances)})</span>
                                </div>
                                <span className="fw-bold text-success small">{formatAmount(dynamicGross)}</span>
                              </div>
                              <div className="border-bottom border-secondary my-0 border-opacity-25"></div>
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex flex-column text-start">
                                  <span className="fw-bold small text-dark">Total Deductions</span>
                                  <span style={{ fontSize: "0.85rem" }}>From Deductions</span>
                                </div>
                                <span className="fw-bold text-danger small">-{formatAmount(totalDeductions)}</span>
                              </div>
                              <div className="border-bottom border-secondary my-0 border-opacity-25"></div>
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex flex-column text-start">
                                  <span className="fw-bold small text-dark">Net Pay</span>
                                  <span style={{ fontSize: "0.85rem" }}>Gross - Deductions</span>
                                </div>
                                <span className="fw-bold text-primary small">{formatAmount(netPay)}</span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center py-5">
                        <NoRecordIcon />
                        <p className="mt-2 text-muted">No salary records found</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
      <LockAttConfirmationModel
        modal={modal}
        toggle={() => toggleModal()}
        submitHandler={handleCreateSalary}
        isLoading={isLoading}
        type={modalType}
        isOffice={isOffice}
      />
    </>
  );
}